import React, { Component } from 'react'
import { Card, Col, Row, Form, Button, Table } from "react-bootstrap-v5";
import { toast } from "react-toastify";
import ReactToPrint from "react-to-print";
import {Spinner} from 'react-bootstrap-v5';
import moment from "moment";
import { reportService } from '../../Services/reportService'
import { retailerService } from '../../Services/retailerService'

const REACT_APP_API_BASEURL = process.env.REACT_APP_API_BASEURL;

class RetailerPerformance extends Component {

    state = {
        reportObj: [],
        retailersObj: [],
        startDate: "",
        endDate: "",
        retailer_name: "",
        loader: false        
    }

    componentDidMount() {
        this.componentRef = React.createRef();
        this.getPerformanceReportData()
        this.getRetailers()
    }

    getRetailers = () => {
        retailerService.getAllRetailer().then(result => {
            if (result.status === true) {
                this.setState({ retailersObj: result.data })
            }
        })
    }

    getPerformanceReportData = (params = {item : 434}) => {
        this.setState({loader:true})
        reportService.getPerformanceReort(params).then(result => {
            if(result.status === true){
                this.setState({reportObj: result.data})
            } else {
                // Something went wrong
            }
        this.setState({loader:false})
        })
    }

    exportToExcel = () => {
        let params = {startDate: this.state.startDate, endDate: this.state.endDate,retailer_name: this.state.retailer_name}
        reportService.exportPerformanceReort(params).then(result => {
            if(result.status === true){
                window.location.href = REACT_APP_API_BASEURL + "/" + result.data;
            } else {
                toast.error("Something went wrong")
            }
        })
    }

    // handleModeChange = (mode) => {
    //     this.setState({retailer_name: mode},()=>{
    //         let search = {startDate: this.state.startDate, endDate: this.state.endDate,retailer_name: this.state.retailer_name}
    //         this.getPerformanceReportData(search)
    //     }) 
    // }

    handleInputChange = (e) => {
            let search = {startDate: this.state.startDate, endDate: this.state.endDate,retailer_name: e.target.value}
            this.getPerformanceReportData(search)
            this.setState({retailer_name: e.target.value})
    }

    // handleDateChange = (e) => {
    //     const { name, value } = e.target
    //     let setdate = name === 'start_date' ? 'startDate' : 'endDate'
    //     this.setState({[setdate] : new Date(value).getTime()}, () => {
    //         if(this.state.startDate !== '' && this.state.endDate !== ""){
    //             let search = {startDate: this.state.startDate, endDate: this.state.endDate,retailer_name: this.state.retailer_name}
    //             this.getPerformanceReportData(search)
    //         }
    //     })
    // }

    handleDateChange = (e) => {
        const { name, value } = e.target;
        let setdate = name === "start_date" ? "startDate" : "endDate";
      
        const selectedDate = new Date(value).getTime();
        this.setState({ [setdate]: selectedDate }, () => {
          const { startDate, endDate } = this.state;
      
          if (startDate !== "" && endDate !== "") {
            if (startDate > endDate) {
              this.setState({ startDate: "", endDate: "" });
              toast.info("Start date cannot be greater than end date.");
            
            } else {
                let search = {startDate: this.state.startDate, endDate: this.state.endDate,retailer_name: this.state.retailer_name}
              this.getPerformanceReportData(search)
            }
          }
        });
      };

    findMode = (textMode) => {
        return (textMode.includes('AIR') && 'AIR')
        || (textMode.includes('COURIER') && 'COURIER')
        || (textMode.includes('SEA') && 'SEA')
        || (textMode.includes('LAND') && 'LAND')
        || 'NA'
    }

    render() {
        const { reportObj, retailersObj } = this.state
        let revTotal = 0, costTotal = 0, profitTotal = 0;

        return (
            <Card>
                <div className="card-header bg-light"><h4>Retailer/Customer Wise Performance</h4></div>
                <Card.Body>
                    <Row>
                        <Col md={3} className="mb-3">
                            {/* <Form.Label>Retailer</Form.Label>
                            <Form.Select name="retailer" onChange={(e) => this.handleModeChange(e.target.value)}>
                                <option value="">All Retailer</option>
                                {
                                    retailersObj.length
                                    && retailersObj.map(item => <option value={item.retailer_name}>{item.retailer_name}</option>)
                                }
                            </Form.Select> */}
                            <Form.Label>Search</Form.Label>
                            <Form.Control
                                type="text"
                                name="search"
                                placeholder='Search Retailer/Customer'
                                onChange={(e) => this.handleInputChange(e)}
                            />
                        </Col>
                        <Col md={3}>
                            <Form.Label>Start Date</Form.Label>
                            <Form.Control
                                type="date"
                                name="start_date"
                                max={new Date().toISOString().split('T')[0]} 
                                onChange={(e) => this.handleDateChange(e)}
                            />
                        </Col>
                        <Col md={3}>
                            <Form.Label>End Date</Form.Label>
                            <Form.Control
                                type="date"
                                name="end_date"
                                max={new Date().toISOString().split('T')[0]} 
                                onChange={(e) => this.handleDateChange(e)}
                            />
                        </Col>
                        <Col md={3} className="mt-3">
                            <div className='d-flex justify-content-end'>
                            <Button className="me-1 ps-4 pe-4" variant="success" onClick={()=> this.exportToExcel()}> Excel </Button>
                            <ReactToPrint
                                trigger={() => {
                                    return <Button variant="secondary" className='ps-4 pe-4' >Print</Button>;
                                }}
                                content={() => this.componentRef}
                                bodyClass={"printElement m-5"}
                            />
                            </div>
                        </Col>
                    </Row>
                    
                    <Row className='printElement' ref={el => (this.componentRef = el)}>
                        <Table striped bordered hover>
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Retailer</th>
                                    <th>Customer</th>
                                    <th>Job Number</th>
                                    <th>Date</th>
                                    <th>Origin</th>
                                    <th>Destination</th>
                                    <th>Revenue</th>
                                    <th>Cost</th>
                                    <th>Profit</th>
                                    <th>Profit in %</th>
                                </tr>
                            </thead>
                             {this.state.loader &&
                    <tbody>
                        <tr>
                            <td colSpan={20} className='text-center'>
                        <Spinner animation="border" />
                            </td>
                        </tr>
                    </tbody> 
                  || 
                            <tbody>
                                {
                                    
                                    reportObj.length 
                                    && reportObj.filter((item)=>{
                                        let retailerToken = item.general_details?.sales_person ? item.general_details.sales_person?.referral_token : ''
                                        let customerName = item?.customer_details?.name
                                            if(retailerToken !== '' || customerName){
                                                return item;
                                            }
                                    }).map((item, index) => {
                                        
                                        let retailerName = item?.general_details?.sales_person?.retailer_name 
                                                           ? item.general_details.sales_person.retailer_name
                                                           : item?.general_details?.retailer_name
                                                            ? item.general_details.retailer_name
                                                            : ''
                                        let customerName = item?.customer_details?.name

                                        let rev = item.invoices 
                                        && item.invoices.invoice_gross_amount
                                        ? item.invoices.invoice_gross_amount : 0
                                        let cost = item.costs 
                                        && item.costs.cost_gross_amount
                                        ? item.costs.cost_gross_amount : 0
                                        let profit = rev-cost
                                        let profitPer = profit!==0 && cost !==0 ? profit / cost : 0
                                        revTotal = rev + revTotal
                                        costTotal = cost + costTotal
                                        profitTotal = profit + profitTotal

                                        return <tr>
                                            <td>{index + 1}</td>
                                            <td>{retailerName}</td>
                                            <td>{customerName}</td>
                                            <td>{item.job_token}</td>
                                            <td>{moment(item.created_at).format("DD-MM-YYYY")}</td>
                                            <td>{item?.shipment_details?.origin 
                                                ? item?.shipment_details?.origin_country
                                                ? item.shipment_details?.origin +", "+ item.shipment_details?.origin_country
                                                : item.shipment_details?.origin
                                                : "-"
                                            }</td>
                                            <td>{item?.shipment_details?.destination 
                                                ? item?.shipment_details?.destination_country
                                                ? item.shipment_details?.destination +", "+ item.shipment_details?.destination_country
                                                : item.shipment_details?.destination
                                                : "-"
                                            }</td>
                                            {/* <td>{item.shipment_details.origin}</td>
                                            <td>{item.shipment_details.destination}</td> */}
                                            <td>{ rev.toFixed(2) }</td>
                                            <td>{ cost.toFixed(2) }</td>
                                            <td>{ profit.toFixed(2) }</td>
                                            <td>{ profitPer.toFixed(2) }</td>
                                        </tr>
                                        
                                    }) || <tr><td colSpan={20} className='text-center'>Data Not Found</td></tr>
                                    
                                }

                                {
                                    <tr>
                                        <td colSpan={7}><strong>Total</strong></td>
                                        <td>{ revTotal.toFixed(2) }</td>
                                        <td>{ costTotal.toFixed(2) }</td>
                                        <td>{ profitTotal.toFixed(2) }</td>
                                        <td colSpan={1}></td>
                                    </tr>
                                }
                                
                            </tbody>
                            }
                        </Table>
                    </Row>
                </Card.Body>
            </Card>
        )
    }
}

export{ RetailerPerformance }
